var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"image-center-empty-mail"},[(_vm.folder)?_c('img',{attrs:{"src":_vm.getTypeofEmpty()}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }